import React from 'react';
import { Typography } from '@fiverr-private/typography';
import { AppI18n } from '../../../i18n';
import { TitleComponentProps } from '..';

export const TitleTimeline = ({ isEditing, color }: TitleComponentProps) => (
  <Typography fontWeight="bold" size="b_md" style={{ whiteSpace: 'pre-line' }} {...(color && { color })}>
    <AppI18n k={isEditing ? 'sections.timeline.when_do_you_need_it' : 'sections.timeline.title'} />
  </Typography>
);
